import { getOscConfig } from "./oneSupportCenterEnv";

const { entitlementsApiEndpoint } = getOscConfig();

const routes = {
  supportPlans: "/v1/support-plans",
};

export const entitlementsRoutes = {
  getSupportPlan: routes.supportPlans,
  updateSupportPlan: routes.supportPlans,
  sendPersonalizedSupportInquiry: `${routes.supportPlans}/personalizedSupport`,
};

export const entitlementsBaseUrl = entitlementsApiEndpoint;
